module.exports = __webpack_public_path__ + "img/LV6.25c80294.webp";